import { FC, useState } from "react";

import { popoutModel } from "shared/ui/popout-root";

import styles from './styles.module.scss'
import { LegalFormDisclaimer } from "shared/ui/legal-form-disclaimer";
import { getNameError, getPhoneError } from "shared/lib/lead-form-validation";
import { useTimedVisibility } from "shared/hooks/use-timed-visibility";

export const Feedback: FC = () => {

    const [name, seteName] = useState({ val: '', edit: 0 });
    const [phone, setPhone] = useState({ val: '', edit: 0 });

    const [isSend, setIsSend] = useState(false)
    const [consentAccepted, setConsentAccepted] = useState(false)

    const nameMsg = getNameError(name.val, name.edit !== 0)
    const phoneMsg = getPhoneError(phone.val, phone.edit !== 0)
    const toastKey = !isSend ? [nameMsg, phoneMsg].filter(Boolean).join(' · ') || null : null
    const showValidationToast = useTimedVisibility(toastKey, 2500)

    const onName = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = e.currentTarget;
        let v = value + '.';

        if (v.slice(-3, -1) === "  ") {
            value = value.slice(0, -1);
        }
        seteName({ val: value.slice(0, 13), edit: 1 });
    }

    const onPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = e.currentTarget;
        let v = value;

        if (v.length === 0) setPhone({ val: '+7', edit: 1 })
        else {
            setPhone({ val: value.slice(0, 13), edit: 1 });
        }
    }


    const sendForm = () => {
        if(isSend) {
            popoutModel.events.setPopout(null)
            return
        }

        if (phone.val.length < 4 || !consentAccepted) {
            return
        }

        fetch('https://itansar.ru/ansar/tg.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                name: name.val,
                phone: phone.val,
                course: 'Нужно помочь выбрать курс'
            })
        })
            .then(() => {
                setIsSend(true)
            })
    }

    return (
        <div className={styles.feedback} id="feedback">
            <div className={styles.__in}>

                <div className={styles.padding}>

                    <div className={styles.left}>
                        <div className={styles.title_section}>
                            Остались вопросы?
                        </div>
                        <div className={styles.text}>
                            Оставьте свои контакты, и мы проконсультируем вас по любым вопросам — от выбора курса до разработки IT-решения для вашего проекта
                        </div>
                    </div>
                    <div className={styles.form}>
                        {!isSend ? (
                            <>
                            <form
                                className={styles.formBlock}
                                onSubmit={(e) => {
                                    e.preventDefault()
                                    sendForm()
                                }}
                                noValidate
                            >
                                <div className={styles.formCard}>
                                    <div className={`${styles.formRow} ${nameMsg ? styles.formRowError : ''}`}>
                                        <label
                                            htmlFor="feedback-name"
                                            className={`${styles.formLabel} ${nameMsg ? styles.formLabelError : ''}`}
                                        >
                                            Имя
                                        </label>
                                        <input
                                            id="feedback-name"
                                            type="text"
                                            name="name"
                                            autoComplete="given-name"
                                            enterKeyHint="next"
                                            value={name.val}
                                            onChange={onName}
                                            className={styles.formInput}
                                            placeholder="Как к вам обращаться"
                                            aria-invalid={Boolean(nameMsg)}
                                        />
                                    </div>
                                    <div className={styles.formDivider} aria-hidden />
                                    <div className={`${styles.formRow} ${phoneMsg ? styles.formRowError : ''}`}>
                                        <label
                                            htmlFor="feedback-phone"
                                            className={`${styles.formLabel} ${phoneMsg ? styles.formLabelError : ''}`}
                                        >
                                            Телефон
                                        </label>
                                        <input
                                            id="feedback-phone"
                                            type="tel"
                                            name="phone"
                                            inputMode="tel"
                                            autoComplete="tel"
                                            enterKeyHint="send"
                                            value={phone.val}
                                            onFocus={onPhone}
                                            placeholder="+7 900 123 45 67"
                                            onChange={onPhone}
                                            className={styles.formInput}
                                            aria-invalid={Boolean(phoneMsg)}
                                        />
                                    </div>
                                </div>

                                <LegalFormDisclaimer
                                    variant="dark"
                                    consentChecked={consentAccepted}
                                    onConsentChange={setConsentAccepted}
                                />

                                <div className={styles.buttonLayout}>
                                    <button
                                        type="submit"
                                        className={styles.submitBtn}
                                        disabled={phone.val.length < 4 || !consentAccepted}
                                    >
                                        Отправить
                                    </button>
                                </div>
                            </form>
                            {showValidationToast && toastKey ? (
                                <div className={styles.formToast} role="alert" aria-live="assertive">
                                    {toastKey}
                                </div>
                            ) : null}
                            </>
                        ) : (
                            <>
                                <div className={styles.sendForm}>
                                    Заявка успешно отправлена! Ожидайте ответа на указанный номер!
                                </div>
                                <div className={styles.buttonLayout}>
                                    <button
                                        type="button"
                                        className={styles.submitBtn}
                                        onClick={sendForm}
                                    >
                                        Закрыть
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}
